import { ReactNode } from 'react';
import {
  DesignButtonSize,
  DesignButtonVariant,
  designButtonClasses,
} from './DesignButton';

export type DesignLinkButtonProps = {
  href: string;
  children: ReactNode;
  variant?: DesignButtonVariant;
  size?: DesignButtonSize;
  className?: string;
  /** Set to render the `download` attribute, e.g. `true` or a file name. */
  download?: boolean | string;
  ariaLabel?: string;
  title?: string;
};

/**
 * `DesignButton` painted onto an `<a>` instead of a `<button>`. Use it where
 * an anchor is the right element - navigating to another URL, or downloading
 * a file with the `download` attribute - so the browser's native behaviour
 * (open in new tab, save target as, `download`) keeps working, which a
 * `<button onClick>` cannot offer.
 */
const DesignLinkButton = ({
  href,
  children,
  variant,
  size,
  className,
  download,
  ariaLabel,
  title,
}: DesignLinkButtonProps) => (
  <a
    href={href}
    download={download}
    aria-label={ariaLabel}
    title={title}
    className={designButtonClasses(variant, size, className)}
  >
    {children}
  </a>
);

DesignLinkButton.defaultProps = {
  variant: 'secondary',
  size: 'md',
  className: '',
  download: undefined,
  ariaLabel: undefined,
  title: undefined,
};

export default DesignLinkButton;
